import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/graphic/play.svg'
import _imports_1 from '@/assets/img/graphic/file-long-inverse.svg'


const _withScopeId = n => (_pushScopeId("data-v-64b7d8ec"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 2,
  class: "video-thumb"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "video-thumb--play",
  src: _imports_0,
  alt: "play icon"
}, null, -1))
const _hoisted_4 = ["video-url"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "file-viewer-img",
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_6 = /*#__PURE__*/_createTextVNode("> ")
const _hoisted_7 = {
  key: 1,
  class: "file-viewer-img",
  src: _imports_1,
  alt: ""
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_lazy_image = _resolveComponent("app-lazy-image")!
  const _component_v_zoomer = _resolveComponent("v-zoomer")!
  const _component_app_video_player = _resolveComponent("app-video-player")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.media.type === 'PHOTO')
      ? (_openBlock(), _createBlock(_component_v_zoomer, {
          key: 0,
          style: {"width":"100%","height":"100%"},
          maxScale: _ctx.zoomable ? 4 : 0
        }, {
          default: _withCtx(() => [
            _createVNode(_component_app_lazy_image, {
              url: `${_ctx.baseURL}${_ctx.media.fileUrl}/${_ctx.PHOTO_VIEW_TYPE.ORIG}`,
              key: _ctx.media.fileUrl,
              "image-fit-contain": ""
            }, null, 8, ["url"])
          ]),
          _: 1
        }, 8, ["maxScale"]))
      : _createCommentVNode("", true),
    (_ctx.media.type === _ctx.MEDIA_TYPES.VIDEO && _ctx.showVideoPlayer && _ctx.currentMedia.id === _ctx.media.id)
      ? (_openBlock(), _createBlock(_component_app_video_player, {
          key: 1,
          url: _ctx.baseURL + _ctx.media.fileUrl,
          pauseVideo: _ctx.pauseVideo,
          onIfVideoPaused: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('ifVideoPaused')))
        }, null, 8, ["url", "pauseVideo"]))
      : (_ctx.media.type === _ctx.MEDIA_TYPES.VIDEO)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("img", {
              src: _ctx.lowResUrlByViewType(_ctx.media, _ctx.PHOTO_VIEW_TYPE.THUMB),
              class: "thumb-img",
              alt: "case photo"
            }, null, 8, _hoisted_2),
            _hoisted_3
          ]))
        : _createCommentVNode("", true),
    (_ctx.media.type === _ctx.MEDIA_TYPES.FILES)
      ? (_openBlock(), _createElementBlock("div", {
          key: 3,
          class: _normalizeClass(["file-viewer", { 'file-viewer--centered': false }])
        }, [
          (_ctx.isPDF)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                "video-url": _ctx.baseURL + _ctx.media.fileUrl
              }, [
                _hoisted_5,
                _hoisted_6,
                _createElementVNode("div", {
                  class: "pdf-link",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openPdf(_ctx.media)))
                }, _toDisplayString(_ctx.$localize('drive.view.file.pdf')), 1)
              ], 8, _hoisted_4))
            : (_openBlock(), _createElementBlock("img", _hoisted_7))
        ]))
      : _createCommentVNode("", true)
  ], 64))
}